import agent from "..//api/agent";
import { RootStore } from "./rootStore";
import { makeAutoObservable, runInAction } from "mobx";
import {
  IQuorumResult,
  ISurvey,
  ISurveyDetail,
  ISurveyDetailsDto,
  // ISurveyResponseDetails,
  ISurveyResultSingle,
  ISurveyResultTotal,
  SurveyDetailFormValues,
  SurveyDetailsPlayerDto,
  SurveyEvent,
  SurveyResponseFormValue,
  Votes,
} from "../models/survey";
import { toast } from "react-toastify";
import {
  ISurveyModal,
  ISurveyResult,
  ISurveyType,
  SurveyReponsesPageDto,
} from "../models/dto";
import { getToastTranslation } from "../helpers/translationHelper";

export default class SurveyStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  surveysArray: ISurvey[] = [];
  rightsurvey: boolean = false;
  surveyDetail: ISurveyDetail | null = null;
  listSurveysType: ISurveyType[] = [];
  // surveysResponsesArray: ISurveyResponseDetails[] = [];
  surveysResponses: SurveyReponsesPageDto | null = null;
  surveysResponsesDetail: any[] | undefined;
  surveysResultTotalArray: ISurveyResultTotal[] = [];
  surveysResultSingleArray: ISurveyResultSingle[] = [];
  quorumDetail: IQuorumResult | null = null;
  showSurveyModal: boolean = false;
  surveyModalTitle: string = "";
  surveyModalParameters: ISurveyModal | null = null;
  surveyModalSignalRParameters: ISurveyModal | null = null;
  isSmallModalOpen: boolean = false;
  actionName: string = "";
  surveyId: number = 0;
  survey: ISurveyDetail | null = null;
  view: "list" | "addEdit" | "vote" | "result" = "list";
  surveyButtonVisible: boolean = false;
  surveyDetails: ISurveyDetailsDto | null = null;
  surveyResultDetails: ISurveyResult | null = null;
  surveyAnswersDetail: SurveyDetailsPlayerDto | null = null;

  get computedSurveyMeetingId() {
    if (this.surveyModalSignalRParameters) {
      return this.surveyModalSignalRParameters.meetingId;
    } else if (this.surveyModalParameters) {
      return this.surveyModalParameters.meetingId;
    } else return null;
  }

  get computedSurveyNodeId() {
    if (this.surveyModalSignalRParameters) {
      return this.surveyModalSignalRParameters.nodeId;
    } else if (this.surveyModalParameters) {
      return this.surveyModalParameters.nodeId;
    } else return 0;
  }

  setSurveyParameters = (meetingId: number, nodeId: number = 0) => {
    this.surveyButtonVisible = true;
    this.surveyModalParameters = { meetingId: meetingId, nodeId: nodeId };
  };

  setSurveySignalRParameters = (meetingId: number, nodeId: number = 0) => {
    this.surveyModalSignalRParameters = {
      meetingId: meetingId,
      nodeId: nodeId,
    };
  };

  resetSurveyParameters = () => {
    this.surveyButtonVisible = false;
    this.surveyModalParameters = null;
  };
  resetSurveySignalRParameters = () => {
    this.surveyModalSignalRParameters = null;
  };

  setView = (value: "list" | "addEdit" | "vote" | "result") => {
    this.view = value;
    this.showSurveyModal = true;
  };

  setSurveyId = (value: number) => {
    this.surveyId = value;
  };

  setActionName = (value: string) => {
    this.actionName = value;
  };

  setIsSmallModalOpen = (value: boolean) => {
    this.isSmallModalOpen = value;
  };
  //RIMETTERE VALORE VIEW SU LIST ------------------------------
  setIsModalOpen = (value: boolean) => {
    this.view = "list";
    this.showSurveyModal = value;
    this.setSurveyId(0);
  };

  //CONDIVISIONE DALL'ADMIN A RISPONDERE AL SONDAGGIO
  OnShowSurveyEvent = (meetingId: number, surveyId: number) => {
    const currentMeeting = this.rootStore.playerStore.attendingMeeting;
    if (currentMeeting && currentMeeting.id === meetingId) {
      this.setSurveySignalRParameters(meetingId);
      this.setSurveyId(surveyId);
      this.setView("vote");
    }
  };

  //CONDIVISIONE DALL'ADMIN DEI RISULTATI DEL SONDAGGIO
  OnShowSurveyResultsEvent = (meetingId: number, surveyId: number) => {
    const currentMeeting = this.rootStore.playerStore.attendingMeeting;
    if (currentMeeting && currentMeeting.id === meetingId) {
      this.setSurveyId(surveyId);
      this.setView("result");
    }
  };

  //CONDIVISIONE DALL'ADMIN DEI RISULTATI DEL SONDAGGIO
  OnUpdateSurveyResultsEvent = (meetingId: number, surveyId: number) => {
    if (this.showSurveyModal) {
      switch (this.view) {
        case "list":
          this.loadSurveys(meetingId);
          break;
        case "result":
          this.LoadSurveyResultDetails(
            meetingId,
            surveyId,
            this.rootStore.commonStore.selectedLanguageId
          );
          break;
        case "vote":
        case "addEdit":
        default:
          break;
      }
    }
  };

  //NOTIFICA EVENTI SU SONDAGGI
  OnReceivedEventOnSurvey = (
    meetingId: number,
    surveyId: number,
    eventType: "Open" | "Close" | "Archivie" | "Clear" | "Delete"
  ) => {
    //GESTISCO GLI EVENTI SOLO SE HO LA FINESTRA DEI SONDAGGI APERTA SUL MEETING CORRETTO
    if (this.computedSurveyMeetingId === meetingId && this.showSurveyModal) {
      switch (this.view) {
        case "list":
          this.loadSurveys(meetingId);
          break;
        case "result":
          if (eventType === "Delete") this.setIsModalOpen(false);
          else
            this.LoadSurveyResultDetails(
              meetingId,
              surveyId,
              this.rootStore.commonStore.selectedLanguageId
            );
          break;
        case "vote":
          if (eventType === "Close") this.setIsModalOpen(false);
          break;
        case "addEdit":
        default:
          break;
      }
    }
  };

  loadSurveys = async (meetingId: number, languageId?: number) => {
    try {
      const dto = await agent.Survey.list(meetingId, languageId);
      runInAction(() => {
        this.surveysArray = dto.surveys;
        this.surveyModalTitle = dto.meetingTitle;
      });
      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  createSurvey = async (survey: SurveyDetailFormValues) => {
    try {
      const createdSurveyId = await agent.Survey.create(survey);
      if (createdSurveyId && this.surveyDetails?.meetingDetails.id) {
        this.LoadSurveyDetail(
          this.surveyDetails?.meetingDetails.id,
          createdSurveyId
        );
      }

      toast.success(getToastTranslation("create_survey_ok"));
      return createdSurveyId;
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("create_survey_error"));
    }
  };

  createSurveyODG = async (survey: SurveyDetailFormValues) => {
    try {
      const createdSurveyId = await agent.Survey.create(survey);
      if (createdSurveyId && this.surveyDetails?.meetingDetails.id) {
        this.LoadSurveyDetail(
          this.surveyDetails?.meetingDetails.id,
          createdSurveyId
        );
      }

      toast.success(getToastTranslation("create_survey_ok"));
      return createdSurveyId;
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("create_survey_error"));
    }
  };

  updateSurvey = async (surveyId: number, survey: SurveyDetailFormValues) => {
    try {
      // console.log("update survey "+surveyId);
      await agent.Survey.update(surveyId, survey);
      // runInAction(() => { this.surveyDetail= survey})
      toast.success(getToastTranslation("update_survey_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("update_survey_error"));
    }
  };

  LoadSurveyDetail = async (meetingId: number, surveyId: number) => {
    try {
      const dto = await agent.Survey.details(meetingId, surveyId);
      runInAction(() => {
        this.rootStore.commonStore.allLanguages = dto.languages;
        this.surveyModalTitle = dto.meetingTitle;
        if (dto.survey) {
          this.surveyDetail = dto.survey;
          this.surveyDetails = dto;
          this.survey = dto.survey;
        }
        //console.log(this.survey);
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  resetSurveyDetails = () => {
    this.surveyDetail = null;
    this.survey = null;
    this.surveyId = 0;
  };

  loadSurveysType = async () => {
    try {
      const dto = await agent.Survey.listSurveyTypes();
      runInAction(() => {
        this.listSurveysType = dto;
      });
      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  LoadSurveyResponses = async (
    meetingId: number,
    surveyQuestionId: number,
    languageId?: number
  ) => {
    try {
      const dto = await agent.Survey.listSurveyResponses(
        meetingId,
        surveyQuestionId
        // languageId
      );
      runInAction(() => {
        this.surveysResponses = dto;
        console.log(this.surveysResponses);
        console.log(dto.surveyResponses);
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  LoadSurveyresponsesDetail = async (surveyResponseId: number) => {
    try {
      const dto = await agent.Survey.detailsResponses(surveyResponseId);
      runInAction(() => {
        if (dto.responsesLanguages) {
          this.surveysResponsesDetail = dto.responsesLanguages;
        }
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  updateSurveyResponse = async (
    surveyResponseId: number,
    surveyResponseLanguages: SurveyResponseFormValue
  ) => {
    try {
      // console.log("update survey "+surveyId);
      await agent.Survey.updateResponses(
        surveyResponseId,
        surveyResponseLanguages
      );
      toast.success(getToastTranslation("update_answer_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("update_answer_error"));
    }
  };

  createSurveyResponse = async (
    surveyId: number,
    surveyResponseLanguages: SurveyResponseFormValue
  ) => {
    try {
      await agent.Survey.AddResponse(surveyId, surveyResponseLanguages);

      toast.success(getToastTranslation("create_answer_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("create_answer_error"));
    }
  };

  deleteSurveyResponse = async (surveyResponseId: number) => {
    try {
      await agent.Survey.deleteResponse(surveyResponseId);

      toast.success(getToastTranslation("delete_answer_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("delete_answer_error"));
    }
  };

  deleteSurvey = async (surveyId: number) => {
    try {
      await agent.Survey.deleteSurvey(surveyId);

      toast.success(getToastTranslation("delete_survey_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("delete_survet_error"));
    }
  };

  EventSurvey = async (surveyId: number, surveyEvent: SurveyEvent) => {
    try {
      let message: string = "";
      await agent.Survey.eventSurvey(surveyId, surveyEvent);
      if (surveyEvent.event === "Close") message = getToastTranslation("close_survey_ok");
      if (surveyEvent.event === "Open") message = getToastTranslation("open_survey_ok");
      if (surveyEvent.event === "Archivie") message = getToastTranslation("archive_survey_ok");
      toast.success(message);
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("survey_generic_error"));
    }
  };

  clearAnswers = async (surveyId: number) => {
    try {
      await agent.Survey.clearAnswers(surveyId);
      toast.success(getToastTranslation("answers_reset_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("answers_reset_error"));
    }
  };

  LoadDetailQuorum = async (meetingId: number, surveyId: number) => {
    try {
      const dto = await agent.Survey.loadQuorumResult(meetingId, surveyId);
      runInAction(() => {
        this.quorumDetail = dto.quorumDetails;
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  loadSurveysBynode = async (NodeId: number) => {
    try {
      const dto = await agent.Survey.loadSurveyByNode(NodeId);
      runInAction(() => {
        this.surveysArray = dto.surveys;
      });
      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  addAnswers = async (
    meetingId: number,
    surveyId: number,
    surveyAnswers: { surveyId: number; surveyResponsesId: number[] }
  ) => {
    try {
      const dto = await agent.Survey.addAnswers(surveyId, surveyAnswers);
      toast.success(getToastTranslation("vote_ok"));
      if (this.surveyAnswersDetail) {
        this.surveyAnswersDetail.answers = surveyAnswers.surveyResponsesId;
        this.surveyAnswersDetail.answerDate = new Date().toString();
      }
      this.LoadSurveyResultDetails(
        meetingId,
        surveyId,
        this.rootStore.commonStore.selectedLanguageId
      );

      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  addFreeAnswer = async (
    meetingId: number,
    surveyId: number,
    answer: string
  ) => {
    try {
      const dto = await agent.Survey.addFreeAnswer(surveyId, answer);
      toast.success(getToastTranslation("free_answer_ok"));
      if (this.surveyAnswersDetail) {
        this.surveyAnswersDetail.answerFree = answer;
        this.surveyAnswersDetail.answerDate = new Date().toString();
      }
      this.LoadSurveyResultDetails(
        meetingId,
        surveyId,
        this.rootStore.commonStore.selectedLanguageId
      );

      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  addAnswerVote = async (
    meetingId: number,
    surveyId: number,
    surveyVote: Votes
  ) => {
    try {
      const dto = await agent.Survey.addAnswerVote(surveyId, surveyVote);
      toast.success(getToastTranslation("vote_answer_ok"));
      if (this.surveyAnswersDetail) {
        this.surveyAnswersDetail.answersVote = surveyVote.votes;
        this.surveyAnswersDetail.answerDate = new Date().toString();
      }
      this.LoadSurveyResultDetails(
        meetingId,
        surveyId,
        this.rootStore.commonStore.selectedLanguageId
      );
      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  LoadSurveyResultDetails = async (
    meetingId: number,
    surveyId: number,
    languageId?: number
  ) => {
    try {
      const dto = await agent.Survey.loadSurveyResult(
        meetingId,
        surveyId,
        languageId
      );
      runInAction(() => {
        this.surveyResultDetails = dto;
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  loadSurveyAnswerDetail = async (
    meetingId: number,
    surveyId: number,
    languageId?: number
  ) => {
    try {
      const dto = await agent.Player.loadSurveyAnswerDetail(
        meetingId,
        surveyId,
        languageId
      );
      runInAction(() => {
        this.surveyAnswersDetail = dto;
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  // METODI DI RESET

  resetStore = () => {
    this.surveysArray = [];
  };

  resetSurveyResultDetail = () => {
    this.surveyResultDetails = null;
  };

  resetSurveyAnswerDetail = () => {
    this.surveyAnswersDetail = null;
  };
}
